var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullPage',{attrs:{"list":_vm.pageList,"homeDataAll":_vm.homeDataAll,"inited":_vm.inited}})
}
var staticRenderFns = []

export { render, staticRenderFns }